export default "__VITE_ASSET__BDwbyAv5__"